<div class="mus-overlay" *ngIf="isOpen" (click)="onOverlayClick()">
  <div class="mus-modal" (click)="$event.stopPropagation()">
    <div class="mus-header">
      <h2 class="mus-title">{{ isDefaultSelectMode() ? 'Select default washes' : 'Drag to Arrange' }}</h2>
      <button type="button" class="mus-close" (click)="onCloseBtn()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>
    <div class="mus-sub" *ngIf="!isDefaultSelectMode()">Custom order for this location</div>

    <div class="mus-body" *ngIf="!loading; else musLoading">
      <div class="mus-top-tabs" *ngIf="!isDefaultSelectMode()">
        <button type="button" class="mus-tab mus-tab--active">Custom 1</button>
      </div>
      <div class="mus-grid">
        <h3
          class="mus-group-title"
          *ngIf="
            singleWash.length ||
            monthlyWash.length ||
            prepaid.length ||
            fleets.length ||
            addOns.length ||
            (discounts.length && !isDefaultSelectMode())
          "
        >
          Packages
        </h3>
        <section class="mus-section mus-section--single-wash" *ngIf="singleWash.length">
          <h3 class="mus-section__label">Single Wash</h3>
          <div
            cdkDropList
            [cdkDropListData]="singleWash"
            class="mus-list mus-list--cols-4"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of singleWash" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
                <span class="mus-card__sub" *ngIf="row.sublabel">{{ row.sublabel }}</span>
              </div>
              <span class="mus-pill" *ngIf="row.pill as pl">{{ pl }}</span>
            </div>
          </div>
        </section>

        <section class="mus-section mus-section--monthly-wash" *ngIf="monthlyWash.length">
          <h3 class="mus-section__label">Monthly Wash</h3>
          <div
            cdkDropList
            [cdkDropListData]="monthlyWash"
            class="mus-list mus-list--cols-3"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of monthlyWash" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
                <span class="mus-card__sub" *ngIf="row.sublabel">{{ row.sublabel }}</span>
              </div>
              <span class="mus-pill" *ngIf="row.pill as pl">{{ pl }}</span>
            </div>
          </div>
        </section>

        <section class="mus-section mus-section--prepaid" *ngIf="prepaid.length">
          <h3 class="mus-section__label">Prepaid</h3>
          <div
            cdkDropList
            [cdkDropListData]="prepaid"
            class="mus-list mus-list--cols-2"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of prepaid" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
                <span class="mus-card__sub" *ngIf="row.sublabel">{{ row.sublabel }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="mus-section mus-section--fleet" *ngIf="fleets.length">
          <h3 class="mus-section__label">Fleet</h3>
          <div
            cdkDropList
            [cdkDropListData]="fleets"
            class="mus-list mus-list--cols-4"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of fleets" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="mus-section mus-section--addons" *ngIf="addOns.length">
          <h3 class="mus-section__label">Add on</h3>
          <div
            cdkDropList
            [cdkDropListData]="addOns"
            class="mus-list mus-list--cols-4"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of addOns" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
                <span class="mus-card__sub" *ngIf="row.sublabel">{{ row.sublabel }}</span>
              </div>
              <span class="mus-pill" *ngIf="row.pill as pl">{{ pl }}</span>
            </div>
          </div>
        </section>

        <section class="mus-section mus-section--discounts" *ngIf="discounts.length && !isDefaultSelectMode()">
          <h3 class="mus-section__label">Discounts</h3>
          <div
            cdkDropList
            [cdkDropListData]="discounts"
            class="mus-list mus-list--cols-3"
            (cdkDropListDropped)="onDrop($event)"
          >
            <div *ngFor="let row of discounts" cdkDrag [cdkDragDisabled]="isDefaultSelectMode()" class="mus-card" [class.mus-card--selectable]="isDefaultSelectMode()" (click)="toggleSelection(row)">
              <span class="mus-card__grip" *ngIf="!isDefaultSelectMode()" aria-hidden="true">⋮⋮</span>
              <span class="mus-card__check" *ngIf="isDefaultSelectMode()">
                <input type="checkbox" [checked]="!!row.selected" (click)="$event.stopPropagation(); toggleSelection(row)" />
              </span>
              <div class="mus-card__main">
                <span class="mus-card__title">{{ row.label }}</span>
                <span class="mus-card__sub" *ngIf="row.sublabel">{{ row.sublabel }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ng-template #musLoading>
      <div class="mus-loading">Loading services…</div>
    </ng-template>

    <div class="mus-footer">
      <button type="button" class="mus-btn mus-btn--ghost" (click)="onCancel()" [disabled]="saving">Cancel</button>
      <button type="button" class="mus-btn mus-btn--primary" (click)="onSave()" [disabled]="saving || loading || (!isDefaultSelectMode() && !sortOrderId)">
        {{ saving ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>
  </div>
</div>
